var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"size":"lg","title":"クーポン発行","hide-footer":""},on:{"hidden":_vm.close},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('user-coupon-code-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }